import { AppThunk } from '../../../store/rootReducer';
import { trackImportDelineation } from '../../analytics/thunks/track-import-delineation.thunk';
import {
  delineationsSelector,
  selectedDelineationIdSelector,
  userDelineationSelector,
} from '../../delineation/selectors/delineation.selectors';
import { importDelineation } from '../../delineation/thunks/import-delineation.thunk';
import * as waveActions from '../actions/wave.actions';
import { Wave } from '../types/wave.type';
import { addFirstWave } from './add-first-wave.thunk';

export const addWave =
  (wave: Wave): AppThunk =>
  async (dispatch, getState) => {
    const userDelineation = userDelineationSelector(getState());
    const selectedDelineationId = selectedDelineationIdSelector(getState());
    const delineations = delineationsSelector(getState());

    // If there are no delineations from the back then there is no selected delineation.
    // We are going to create the user delineation with this wave its first and make this the selected one
    if (delineations.length === 0) {
      return dispatch(addFirstWave(wave));
    }

    if (selectedDelineationId == null) {
      return;
    }

    if (userDelineation == null) {
      dispatch(trackImportDelineation('wave'));
      await dispatch(importDelineation(selectedDelineationId));
    }

    dispatch(waveActions.add({ wave }));
  };
